import { Component, OnInit } from '@angular/core';
import { CardService } from '../../services/card.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'pa-card-eula',
  templateUrl: './card-eula.component.html',
  styleUrls: ['./card-eula.component.scss']
})
export class CardEulaComponent implements OnInit {
  contractUrl: string;
  trackingId: string;

  constructor(private router: Router, private cardService: CardService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.cardService.getEula(this.trackingId).subscribe(response => {
      if (response != null) {
        this.contractUrl = response.cardEulaUrl;
      }
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

}
